/* No build tools or network requests. Add milestone <article>s in about.html. */
(() => {
 'use strict';
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const motion=()=>reduced.matches?'auto':'smooth';
 function init(root){
 root.querySelectorAll('.about-carousel').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const track=root.querySelector('.carousel-track'),nav=root.querySelector('.carousel-nav');
  const originals=[...track.children],total=originals.length;
  if(!total)return;
  const loop=root.dataset.carousel==='materials'&&total>1;
  let active=0,frame=0,settleTimer=0,repositioning=false,resizeTimer=0,touching=false;
  const prev=root.querySelector('.carousel-prev'),next=root.querySelector('.carousel-next');
  const count=root.querySelector('.carousel-counter');
  const navWindow=root.querySelector('.timeline-window');
  originals.forEach((card,i)=>{card.dataset.index=i;card.id=`${root.dataset.carousel}-slide-${i}`;card.setAttribute('role','group');card.setAttribute('aria-roledescription','スライド');card.setAttribute('aria-label',`${i+1} / ${total}`);});
  if(loop){
   const copies=()=>originals.map(card=>{const clone=card.cloneNode(true);clone.removeAttribute('id');clone.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));clone.setAttribute('aria-hidden','true');clone.dataset.clone='true';clone.querySelectorAll('a,button').forEach(el=>el.tabIndex=-1);return clone;});
   track.prepend(...copies());track.append(...copies());
  }
  const cards=[...track.children];
  const buttons=originals.map((card,i)=>{
   const b=document.createElement('button');b.type='button';b.setAttribute('aria-controls',card.id);
   b.setAttribute('aria-label',`${card.dataset.year||''} ${card.dataset.title}へ移動`.trim());
   if(navWindow){const year=document.createElement('span'),dot=document.createElement('i'),title=document.createElement('small');year.textContent=card.dataset.year;dot.setAttribute('aria-hidden','true');title.textContent=card.dataset.title;b.append(year,dot,title);}
   b.addEventListener('click',()=>go(i));nav.append(b);return b;
  });
  const centerOf=card=>card.offsetLeft-(track.clientWidth-card.offsetWidth)/2;
  // offsetLeft is relative to the positioned carousel, whose left edge matches the track.
  function nearest(){let best=0,distance=Infinity;cards.forEach((card,i)=>{const d=Math.abs(centerOf(card)-track.scrollLeft);if(d<distance){distance=d;best=i;}});return best;}
  function updateNav(i,force=false){
   const changed=active!==i;active=i;
   buttons.forEach((b,j)=>{if(j===i)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});
   if(count)count.textContent=`${String(i+1).padStart(2,'0')} / ${String(total).padStart(2,'0')}`;
   if(!loop){prev.disabled=i===0;next.disabled=i===total-1;}
   if(navWindow&&(changed||force)){
    const b=buttons[i],n=navWindow.getBoundingClientRect(),r=b.getBoundingClientRect();
    navWindow.scrollTo({left:navWindow.scrollLeft+r.left-n.left-(n.width-r.width)/2,behavior:force?'auto':motion()});
   }
  }
  function paint(){
   frame=0;
   cards.forEach(card=>{const distance=Math.abs(centerOf(card)-track.scrollLeft);const focus=Math.max(0,1-distance/(card.offsetWidth+24));card.style.setProperty('--slide-scale',String(.9+.1*focus));card.style.setProperty('--slide-opacity',String(.62+.38*focus));card.style.setProperty('--slide-shade',String(.25*(1-focus)));});
   updateNav(Number(cards[nearest()].dataset.index));
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(paint);}
  function jump(card){
   repositioning=true;track.classList.add('is-repositioning');track.scrollTo({left:centerOf(card),behavior:'instant'});paint();
   requestAnimationFrame(()=>{track.classList.remove('is-repositioning');repositioning=false;});
  }
  function settle(){
   if(touching||repositioning)return;
   const card=cards[nearest()];
   if(loop&&card.dataset.clone)jump(originals[Number(card.dataset.index)]);
  }
  function go(i){
   const wanted=loop?(i+total)%total:Math.max(0,Math.min(total-1,i));
   const current=nearest();let target=originals[wanted];
   if(loop){const matches=cards.filter(c=>Number(c.dataset.index)===wanted);target=matches.reduce((best,c)=>Math.abs(cards.indexOf(c)-current)<Math.abs(cards.indexOf(best)-current)?c:best,matches[0]);}
   track.scrollTo({left:centerOf(target),behavior:motion()});
  }
  originals.forEach((card,i)=>card.addEventListener('focusin',()=>go(i)));
  prev.addEventListener('click',()=>go(active-1));next.addEventListener('click',()=>go(active+1));
  root.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;if(e.target.closest('a,input'))return;e.preventDefault();const i=e.key==='Home'?0:e.key==='End'?total-1:active+(e.key==='ArrowRight'?1:-1);go(i);if(nav.contains(e.target))buttons[loop?(i+total)%total:Math.max(0,Math.min(total-1,i))].focus({preventScroll:true});});
  track.addEventListener('scroll',()=>{schedule();clearTimeout(settleTimer);settleTimer=setTimeout(settle,180);},{passive:true});
  track.addEventListener('scrollend',settle);
  track.addEventListener('pointerdown',()=>{touching=true;});
  const release=()=>{if(touching){touching=false;clearTimeout(settleTimer);settleTimer=setTimeout(settle,220);}};
  addEventListener('pointerup',release);addEventListener('pointercancel',release);
  const resize=()=>{clearTimeout(resizeTimer);resizeTimer=setTimeout(()=>{jump(originals[active]);updateNav(active,true);},100);};
  if('ResizeObserver' in window)new ResizeObserver(resize).observe(track);else addEventListener('resize',resize);
  reduced.addEventListener('change',()=>jump(originals[active]));
  // Animate card opacity independently of the inner carousel scale and hover zoom.
  if(root.dataset.carousel==='materials'&&!reduced.matches&&'IntersectionObserver' in window){
   root.classList.add('entry-ready');
   const entryObserver=new IntersectionObserver(entries=>{
    if(!entries.some(entry=>entry.isIntersecting))return;
    const center=nearest();
    cards.forEach((card,index)=>{
     const distance=index-center;
     const order=distance===0?0:Math.abs(distance)*2-(distance<0?1:0);
     card.style.setProperty('--entry-delay',`${Math.min(order,4)*.22}s`);
    });
    root.classList.add('entry-visible');entryObserver.disconnect();
   },{threshold:.15});
   requestAnimationFrame(()=>requestAnimationFrame(()=>entryObserver.observe(track)));
   reduced.addEventListener('change',()=>{if(reduced.matches){entryObserver.disconnect();root.classList.remove('entry-ready');}});
  }
  requestAnimationFrame(()=>{jump(originals[0]);updateNav(0,true);});
 });

 // Draw each outline clockwise from twelve o'clock as it enters the viewport.
 const circles=[...root.querySelectorAll('.material-circle')];
 if(!reduced.matches&&'IntersectionObserver' in window){
  const circleObserver=new IntersectionObserver(entries=>{
   entries.forEach(entry=>{if(entry.isIntersecting){
    const circle=entry.target;
    const finish=()=>circle.classList.add('line-complete');
    circle.querySelector('circle').addEventListener('transitionend',finish,{once:true});
    circle.classList.add('line-drawn');
    // Also finalize after background-tab throttling or a missed transition event.
    setTimeout(finish,2800);
    circleObserver.unobserve(circle);
   }});
  },{threshold:.35});
  circles.forEach((circle,index)=>{
   circle.style.setProperty('--line-delay',matchMedia('(min-width:641px)').matches?`${index*.14}s`:'0s');
   circle.classList.add('line-ready');circleObserver.observe(circle);
  });
  reduced.addEventListener('change',()=>{if(reduced.matches){circleObserver.disconnect();circles.forEach(circle=>circle.classList.remove('line-ready'));}});
 }

 const marquee=root.querySelector('.marquee-track'),marqueeToggle=root.querySelector('.marquee-toggle');
 if(marquee&&marqueeToggle&&!marquee.dataset.ready){marquee.dataset.ready='true';
 let marqueePaused=reduced.matches;
 function syncMarquee(){marqueeToggle.disabled=reduced.matches;marquee.classList.toggle('is-paused',marqueePaused||document.hidden);marqueeToggle.textContent=marqueePaused?'▶':'Ⅱ';marqueeToggle.setAttribute('aria-pressed',String(marqueePaused));marqueeToggle.setAttribute('aria-label',marqueePaused?'流れるテキストを再開':'流れるテキストを一時停止');}
 function sizeMarquee(){
  const first=marquee.querySelector('.marquee-set');
  const width=first.getBoundingClientRect().width;
  if(!width)return;
  const needed=Math.max(2,Math.ceil(marquee.parentElement.clientWidth/width)+1);
  while(marquee.children.length>needed)marquee.lastElementChild.remove();
  while(marquee.children.length<needed){
   const copy=first.cloneNode(true);copy.setAttribute('aria-hidden','true');
   copy.querySelectorAll('a').forEach(link=>link.tabIndex=-1);
   copy.querySelectorAll('[data-shopify-editor-block]').forEach(item=>item.removeAttribute('data-shopify-editor-block'));
   marquee.append(copy);
  }
  marquee.style.setProperty('--marquee-distance',`${-width}px`);
  marquee.style.setProperty('--marquee-duration',`${width/38}s`);
 }
 const marqueeResize=new ResizeObserver(sizeMarquee);marqueeResize.observe(marquee.parentElement);marqueeResize.observe(marquee.querySelector('.marquee-set'));
 marqueeToggle.addEventListener('click',()=>{marqueePaused=!marqueePaused;syncMarquee();});
 reduced.addEventListener('change',()=>{marqueePaused=reduced.matches;syncMarquee();});
 document.fonts?.ready.then(sizeMarquee);sizeMarquee();syncMarquee();

 document.addEventListener('visibilitychange',syncMarquee);
 }
 const section=root.querySelector('.who-section');if(!section||section.dataset.ready)return;section.dataset.ready='true';
 const media=section.querySelector('.who-media'),video=media.querySelector('video'),videoToggle=section.querySelector('.video-toggle');
 const VIDEO={desktop:video.dataset.desktopSrc||'',mobile:video.dataset.mobileSrc||''};
 const mobile=matchMedia('(max-width:640px)');
 let videoPaused=false,visible=false,parallaxFrame=0;
 function chooseVideo(){const src=mobile.matches?(VIDEO.mobile||VIDEO.desktop):VIDEO.desktop;if(!src){video.pause();media.classList.remove('has-video');videoToggle.hidden=true;return;}if(video.getAttribute('src')!==src){media.classList.remove('has-video');video.src=src;video.load();}videoToggle.hidden=false;syncVideo();}
 function syncVideo(){if(!video.getAttribute('src'))return;const shouldPlay=visible&&!document.hidden&&!videoPaused&&!reduced.matches;if(shouldPlay){video.muted=true;video.play().catch(()=>{videoToggle.hidden=false;videoToggle.textContent='▶';videoToggle.setAttribute('aria-label','背景動画を再生');});}else video.pause();videoToggle.textContent=video.paused?'▶':'Ⅱ';videoToggle.setAttribute('aria-label',video.paused?'背景動画を再生':'背景動画を一時停止');}
 video.addEventListener('playing',()=>{media.classList.add('has-video');videoToggle.textContent='Ⅱ';videoToggle.setAttribute('aria-label','背景動画を一時停止');});
 video.addEventListener('error',()=>{media.classList.remove('has-video');videoToggle.hidden=true;});
 videoToggle.addEventListener('click',()=>{if(video.paused){videoPaused=false;if(reduced.matches){video.play().catch(()=>{});return;}}else videoPaused=true;syncVideo();});
 function parallax(){parallaxFrame=0;if(!visible||reduced.matches){media.style.transform='';return;}const rect=section.getBoundingClientRect(),progress=Math.max(0,Math.min(1,(innerHeight-rect.top)/(rect.height+innerHeight)));const amount=(progress-.5)*(mobile.matches?80:120);media.style.transform=`translate3d(0,${amount.toFixed(2)}px,0)`;}
 function queueParallax(){if(!parallaxFrame&&visible)parallaxFrame=requestAnimationFrame(parallax);}
 if('IntersectionObserver' in window)new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;syncVideo();parallax();},{threshold:0}).observe(section);else visible=true;
 addEventListener('scroll',queueParallax,{passive:true});addEventListener('resize',queueParallax);
 mobile.addEventListener('change',chooseVideo);reduced.addEventListener('change',()=>{syncVideo();parallax();});
 document.addEventListener('visibilitychange',()=>{syncVideo();});chooseVideo();
}
 init(document);document.addEventListener('shopify:section:load',event=>init(event.target));
})();
